import { appMethod as app } from '@utils/app';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './GoodsCustomerService.less';

export default class GoodsCustomerService extends OfficialPage {
  state = {
    orderStatus: [
      '待审核',
      '退款失败',
      '退款失败',
      '退货中',
      '待商家确认收货',
      '退款失败',
      '退款成功',
      '退款失败'
    ],
    orderReason: [
      '待审核',
      '商家拒绝退款',
      '买家撤销退款',
      '待买家退货',
      '待商家确认收货',
      '商家超时未退货',
      '已退款',
      '商家超时未处理退款'
    ],
    refundType: ['全额退款', '部分退款', '退货退款'],
    orderInfo: []
  }
  page = 1
  isMore = 0

  constructor(props) {
    super(props);
    document.title = '售后订单';
  }

  componentWillMount() {}

  componentDidMount() {
    this.dataInitial()
  }

  dataInitial = () => {
    this.setData({
      orderInfo: []
    })
    this.page = 1
    this.getAfterSaleOrderList()
  }
  // TODO
  onReachBottom = () => {
    if (!this.isMore) {
      return
    }
    this.page++
    this.getAfterSaleOrderList()
  }
  getAfterSaleOrderList = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/getAfterSaleOrderList',
      method: 'post',
      data: {
        page: _this.page,
        page_size: 10
      },
      success: function (res) {
        _this.isMore = res.is_more
        let orderInfo = _this.data.orderInfo.concat(res.data)
        _this.setData({
          orderInfo: orderInfo
        })
      }
    })
  }
  toGoodsOrderDetail = event => {
    let orderId = event.currentTarget.dataset.orderId
    let franchiseeId = event.currentTarget.dataset.franchiseeId
    let applyId = event.currentTarget.dataset.applyId
    franchiseeId = franchiseeId != app.getAppId() ? franchiseeId : ''
    let router =
      '/eCommerce/pages/goodsAfterSaleDetail/goodsAfterSaleDetail?applyId=' +
      applyId +
      '&detail=' +
      orderId +
      (franchiseeId ? '&franchisee=' + franchiseeId : '')
    app.turnToPage(router)
  }
  deleteAfterSale = event => {
    let orderId = event.currentTarget.dataset.orderId
    let applyId = event.currentTarget.dataset.applyId
    let index = event.currentTarget.dataset.index
    let _this = this
    app.showModal({
      content: '确认删除记录？',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=AppShop/deleteAfterSaleOrderLog',
          method: 'post',
          data: {
            order_id: orderId,
            apply_id: applyId
          },
          success: function (res) {
            let orderInfo = _this.data.orderInfo
            orderInfo.splice(index, 1)
            _this.setData({
              orderInfo: orderInfo
            })
          }
        })
      }
    })
  }
  cancelRefund = event => {
    let _this = this
    let parentId = event.currentTarget.dataset.parentId
    let orderId = event.currentTarget.dataset.orderId
    let franchiseeId = parentId ? app.getAppId() : ''
    app.showModal({
      content: '确认撤销申请？',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=appShop/cancelRefund',
          data: {
            order_id: orderId,
            sub_shop_app_id: franchiseeId
          },
          success: function () {
            _this.dataInitial()
          }
        })
      }
    })
  }
  refuseReason = event => {
    let reason = event.currentTarget.dataset.reason
    app.showModal({
      content: reason
    })
  }

  render() {
    const { orderInfo, orderStatus, refundType, orderReason } = this.state
    return (
      <div className="official-page goods-customer-service">
        <TopNav title="售后订单" />
        {orderInfo.map((item, index) => {
          return (
            <div className="goods-customer-contain" key={item.id}>
              <div className="goods-customer-header">
                <div>
                  <span className="customer-add-time">{item.add_time}</span>
                  <span
                    className={
                      'pull-right ' +
                      (item.status == 0 || item.status == 4
                        ? 'waiting-color'
                        : '')
                    }
                  >
                    {orderStatus[item.status]}
                  </span>
                </div>
              </div>
              {item.refund_goods_info.map((goods, index) => {
                return (
                  <div
                    onClick={this.toGoodsOrderDetail}
                    data-apply-id={item.id}
                    data-order-id={item.order_id}
                    data-franchisee-id={item.app_id}
                    className="goods-customer-content"
                    key={goods.goods_id}
                  >
                    <img src={goods.cover} />
                    <div className="goods-detail-box">
                      <div className="goods-title">{goods.title}</div>
                      {goods.model_name && (
                        <div className="goods-model">{goods.model_name}</div>
                      )}
                      <div className="goods-price-box">
                        <span>{'¥' + goods.price}</span>
                        <span className="pull-right goods-num">
                          {'x' + goods.num}
                        </span>
                      </div>
                    </div>
                  </div>
                )
              })}
              <div className="goods-customer-bottom">
                <div className="order-refund-box">
                  <div className="order-status-explain">
                    <span className="ico-moon icon-goods-after-sale"></span>
                    <span>{refundType[item.refund_type]}</span>
                  </div>
                  {(item.status == 1 ||
                    item.status == 2 ||
                    item.status == 5 ||
                    item.status == 7) && (
                      <span className="pull-right order-refund-price">
                        {orderReason[item.status]}
                      </span>
                    )}
                  {item.status == 3 && (
                    <span className="pull-right order-refund-price">
                      {'等待商家发货，还剩' + item.expire}
                    </span>
                  )}
                  {item.status == 6 && (
                    <span className="pull-right order-refund-price">
                      {'退款金额 ¥' + item.refund_price}
                    </span>
                  )}
                </div>
                <div className="customer-btn-box">
                  {item.status == 0 && (
                    <span
                      className="customer-btn"
                      onClick={this.cancelRefund}
                      data-order-id={item.order_id}
                      data-apply-id={item.id}
                      data-franchisee-id={item.app_id}
                    >
                      撤销申请
                    </span>
                  )}
                  {(item.status == 1 ||
                    item.status == 2 ||
                    item.status == 5 ||
                    item.status == 6) && (
                      <span
                        className="customer-btn"
                        onClick={this.deleteAfterSale}
                        data-order-id={item.order_id}
                        data-apply-id={item.id}
                        data-index={index}
                      >
                        删除记录
                    </span>
                    )}
                  {item.status == 1 && (
                    <span
                      className="customer-btn"
                      onClick={this.refuseReason}
                      data-reason={item.refuse_msg}
                    >
                      拒绝原因
                    </span>
                  )}
                  <span
                    className="customer-btn"
                    onClick={this.toGoodsOrderDetail}
                    data-apply-id={item.id}
                    data-order-id={item.order_id}
                    data-franchisee-id={item.app_id}
                  >
                    查看订单
                  </span>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/goods-customer-service/GoodsCustomerService.jsx